
const digest = '8d7308b9deddecd84ab026a2ea3ea47d64c8422afb346af4709febac0692d645';
const classes = {"modal":"_modal_16aay_1","header":"_header_16aay_6","body":"_body_16aay_10","field":"_field_16aay_18","labelRow":"_labelRow_16aay_27","source":"_source_16aay_34","filePreview":"_filePreview_16aay_39","texts":"_texts_16aay_48","fileName":"_fileName_16aay_55","meta":"_meta_16aay_62","fileList":"_fileList_16aay_67","fileRow":"_fileRow_16aay_75","newFolder":"_newFolder_16aay_86","newFolderPlus":"_newFolderPlus_16aay_99","folders":"_folders_16aay_110","folder":"_folder_16aay_110","folderRoot":"_folderRoot_16aay_150","folderSelected":"_folderSelected_16aay_162","radio":"_radio_16aay_168","folderName":"_folderName_16aay_174","count":"_count_16aay_179","hint":"_hint_16aay_201","footer":"_footer_16aay_215","note":"_note_16aay_220"};
const css = `._modal_16aay_1 {
  width: 620px;
  font-family: var(--md-font-family);
}

._header_16aay_6 {
  padding-bottom: 20px;
}

._body_16aay_10 {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-top: 0;
  padding-bottom: 26px;
}

._field_16aay_18 {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
._field_16aay_18 [class*="Label-module_wrapper"] {
  margin: 0;
}

._labelRow_16aay_27 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

._source_16aay_34 {
  font-size: 12px;
  color: var(--md-color-text-secondary);
}

._filePreview_16aay_39 {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  border-radius: 8px;
  background: var(--md-color-surface-muted);
}

._texts_16aay_48 {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

._fileName_16aay_55 {
  font-size: 14px;
  font-weight: 500;
  color: var(--md-black);
  overflow-wrap: anywhere;
}

._meta_16aay_62 {
  font-size: 12px;
  color: var(--md-color-text-secondary);
}

._fileList_16aay_67 {
  list-style: none;
  margin: 0;
  padding: 0;
  border-radius: 8px;
  background: var(--md-color-surface-muted);
}

._fileRow_16aay_75 {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
}

._fileRow_16aay_75 + ._fileRow_16aay_75 {
  border-top: 1px solid var(--md-color-border-light);
}

._newFolder_16aay_86 {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  border: 0;
  background: none;
  font-size: 13px;
  font-weight: 500;
  color: var(--md-color-primary);
  cursor: pointer;
}

._newFolderPlus_16aay_99 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  border-radius: 7px;
  background: var(--md-color-surface-tab);
  color: var(--md-color-text-secondary);
}

._folders_16aay_110 {
  list-style: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
  border: 1px solid var(--md-color-border-subtle);
  border-radius: 8px;
}

._folders_16aay_110 li + li {
  border-top: 1px solid var(--md-color-border-light);
}

._folder_16aay_110 {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px 16px 12px 40px;
  border: 0;
  background: var(--md-white);
  font-size: 14px;
  color: var(--md-black);
  text-align: left;
  cursor: pointer;
}
._folder_16aay_110 svg {
  flex-shrink: 0;
  color: var(--md-color-primary);
}
._folder_16aay_110:hover {
  background: #f7fafe;
}
._folder_16aay_110:focus {
  outline: none;
}
._folder_16aay_110:focus-visible {
  box-shadow: inset 0 0 0 2px var(--md-color-primary);
}

._folderRoot_16aay_150 {
  padding-left: 16px;
  font-weight: 500;
  cursor: default;
}
._folderRoot_16aay_150 svg {
  color: var(--md-color-text-secondary);
}
._folderRoot_16aay_150:hover {
  background: var(--md-white);
}

._folderSelected_16aay_162,
._folderSelected_16aay_162:hover {
  background: var(--md-color-primary-soft);
  color: var(--md-color-primary-soft-text);
  font-weight: 500;
}
._folderSelected_16aay_162 ._radio_16aay_168,
._folderSelected_16aay_162:hover ._radio_16aay_168 {
  border-color: var(--md-color-primary);
  background: var(--md-color-primary);
}

._folderName_16aay_174 {
  flex: 1;
  min-width: 0;
}

._count_16aay_179 {
  font-size: 12px;
  font-weight: 400;
  color: var(--md-color-text-key);
}

._radio_16aay_168 {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  border: 1px solid var(--md-color-border-subtle);
  border-radius: 10px;
  background: var(--md-white);
  color: var(--md-white);
}
._radio_16aay_168 svg {
  color: var(--md-white);
}

._hint_16aay_201 {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  padding-left: 4px;
  font-size: 12px;
  color: var(--md-color-text-secondary);
}
._hint_16aay_201 svg {
  flex-shrink: 0;
  color: var(--md-color-primary);
}

._footer_16aay_215 {
  gap: 20px;
  padding: 22px 30px;
}

._note_16aay_220 {
  font-size: 13px;
  color: var(--md-color-text-secondary);
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  